function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M338.8,198.7H173.2c-9.1,0-16.6,7.4-16.6,16.6v16.6c0,9.1,7.4,16.6,16.6,16.6h165.6c9.1,0,16.6-7.4,16.6-16.6v-16.6 C355.3,206.1,347.9,198.7,338.8,198.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M504.4,41.3C504.4,18.5,485.8,0,463,0H49C26.2,0,7.6,18.5,7.6,41.3L6.7,389c-0.1,22.9,18.5,41.5,41.4,41.5h121.7l54.2,66.3 c16.6,20.2,47.5,20.2,64.1,0l54.2-66.3h121.7c22.9,0,41.5-18.6,41.4-41.5L504.4,41.3z M318.7,380.8L256,457.5l-62.7-76.7H56.4 l0.9-331.2h397.5l0.9,331.2H318.7z"
}));

function SvgInbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/inbox.6aac2024.svg";
export { ForwardRef as ReactComponent };